export const APP_CONSTANTS = {
  TITLE_SEPARATOR: ' | ',
  APP_NAME: 'PowerReady',
  EID_CONFIGID: 'EidConfig'
};
